import type { NewsletterModel } from "./NewsletterModel";
import type { NewsletterMapping } from "./Newsletter.typed";

export class NewsletterAdapter {
  constructor(private model: NewsletterModel) {}
  async getNewsletterMapping(): Promise<NewsletterMapping> {
    return this.model.getNewsletterMapping();
  }
  async updateNewsletterMapping(mapping: NewsletterMapping): Promise<void> {
    return this.model.updateNewsletterMapping(mapping);
  }
}
